__turbopack_context__.v({
  "pagination": "AppDetails-module__QuylEW__pagination",
  "section": "AppDetails-module__QuylEW__section",
  "sectionHeader": "AppDetails-module__QuylEW__sectionHeader",
});
